export default "__VITE_ASSET__CdKSBeom__"